module.exports = __webpack_public_path__ + "img/e_3_18_g.7e047fe3.png";